import { NftItemRarity } from 'src/utils/types';
import bgDecoCommon from 'assets/img/bg_deco_hero_common.png';
import bgDecoEpic from 'assets/img/bg_deco_hero_epic.png';
import bgDecoLegendary from 'assets/img/bg_deco_hero_legendary.png';
export const heroRarityStyleMap = {
  [NftItemRarity.COMMON]: {
    rarityType: 'common',
    deco: bgDecoCommon
  },
  [NftItemRarity.EPIC]: {
    rarityType: 'epic',
    deco: bgDecoEpic
  },
  [NftItemRarity.LEGENDARY]: {
    rarityType: 'legendary',
    deco: bgDecoLegendary
  }
};